// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAJfjka6hJYPHzt1qWu1x8t8WbrsduDPAo",
  authDomain: "taim-bd594.firebaseapp.com",
  projectId: "taim-bd594",
  storageBucket: "taim-bd594.firebasestorage.app",
  messagingSenderId: "744202630496",
  appId: "1:744202630496:web:6cad0903c4bada33e8da05",
  measurementId: "G-ZNH72FKDP1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// 3. auth 객체를 생성합니다.
const auth = getAuth(app);
// 4. 생성한 auth 객체를 export하여 다른 파일에서 import 할 수 있게 합니다.
export { auth };